/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEventCreateRequestBaseResponse as ModelsWebhookWebhookEventCreateRequestBaseResponse } from '../../models/Models/Webhook/webhook-event-create-request-base-response';

export interface V4WebhooksDeregisterDelete$Plain$Params {
}

export function v4WebhooksDeregisterDelete$Plain(http: HttpClient, rootUrl: string, params?: V4WebhooksDeregisterDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4WebhooksDeregisterDelete$Plain.PATH, 'delete');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>;
    })
  );
}

v4WebhooksDeregisterDelete$Plain.PATH = '/v4/webhooks/deregister';
